/* AagamStuti order note and gift note. Saves what the shopper types on the bag and offers AS.flush, which aagamstuti-cart.js calls before it redraws the bag, so nothing typed is lost. */
(function () {
  'use strict';
  var AS = window.AS = window.AS || {}, routes = AS.routes || {}, doc = document, cartUrl = routes.cart || '/cart';
  function $(s, c) { return (c || doc).querySelector(s); }
  var timers = {}, jobs = {};

  function send(data) {
    return fetch(cartUrl + '/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(data) })
      .then(function (r) { return r.ok; }, function () { return false; });
  }
  function queue(key, job, wait) {
    clearTimeout(timers[key]); jobs[key] = job;
    timers[key] = setTimeout(function () { run(key); }, wait);
  }
  function run(key) {
    clearTimeout(timers[key]);
    var job = jobs[key]; delete jobs[key];
    return job ? job() : Promise.resolve();
  }
  AS.flush = function () { return Promise.all(Object.keys(jobs).map(run)); };

  function saveGift(box) {
    var on = $('[data-gift-toggle]', box).checked, hint = $('[data-gift-hint]', box);
    return send({ attributes: { 'Gift': on ? 'Yes' : '', 'Gift message': on ? $('[data-gift-msg]', box).value.trim() : '' } }).then(function (ok) {
      if (!hint) return;
      if (!hint.hasAttribute('data-was')) hint.setAttribute('data-was', hint.textContent);
      hint.textContent = ok ? hint.getAttribute('data-was') : 'We could not save this just now. Please try again.';
      if (ok) hint.removeAttribute('role'); else hint.setAttribute('role', 'alert');
    });
  }

  doc.addEventListener('change', function (e) {
    var t = e.target;
    if (!t || !t.matches || !t.matches('[data-gift-toggle]')) return;
    var box = t.closest('[data-gift]'), fields = $('[data-gift-fields]', box);
    fields.hidden = !t.checked;
    if (t.checked) $('[data-gift-msg]', box).focus();
    queue('gift', function () { return saveGift(box); }, 0);
  });
  doc.addEventListener('input', function (e) {
    var t = e.target;
    if (!t) return;
    if (t.id === 'cart-note') {
      queue('note', function () { return send({ note: t.value }); }, 600);
    } else if (t.matches && t.matches('[data-gift-msg]')) {
      var box = t.closest('[data-gift]');
      queue('gift', function () { return saveGift(box); }, 600);
    }
  });
})();
